

























import { Component, Prop, Vue } from 'vue-property-decorator'
// @ts-ignore
import { Picker } from 'emoji-mart-vue-fast'
// @ts-ignore
import Popper from 'vue-popperjs'

// i18n emoji language files
import ja from '@/lang/emojiJA'
import en from '@/lang/emojiEN'

@Component({
  components: {
    Picker,
    Popper
  }
})
export default class EmojiPopup extends Vue {
  @Prop() emojiIndex: any

  get emojiI18n() {
    switch (this.$store.state.setting.setting.setting_language.code) {
      case 'ja':
        return ja
      case 'en':
        return en
      default:
        return ja
    }
  }

  onResetEmojiState() {
    const popperWrapperRef = this.$refs.popperRef as any
    const popper = popperWrapperRef.popper
    const searchInput = popper.querySelector(
      'input[type="text"]'
    ) as HTMLInputElement
    if (searchInput) {
      searchInput.value = ''
      searchInput.dispatchEvent(new Event('input'))
    }
    popperWrapperRef.doClose()
  }

  onHidePopper() {
    this.onResetEmojiState()
  }

  onAddEmoji(emoji: any) {
    this.$emit('onAddEmoji', emoji)
    this.onResetEmojiState()
  }
}
